import React from "react";
import { useSelector } from "react-redux";
import { fontSizes, iconButtonSize, iconWidth, inlineTextIconMargin, media, styled } from "@iventis/styles";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { DigitalTwinCameraMode } from "@iventis/domain-model/model/digitalTwinCameraMode";
import { Content } from "@iventis/translations";
import { map } from "./state/map.slice";
import { dispatch, RootState } from "./state/root.store";

export const DigitalTwinCameraModeButtonsComponent: React.FunctionComponent = () => {
    const translate = useIventisTranslate();

    const setCameraMode = (mode: DigitalTwinCameraMode) => {
        dispatch(map.actions.setCameraMode({ value: mode, stamp: true }));
    };

    const cameraMode = useSelector((state: RootState) => state.mapReducer.mapModule.digitalTwinEngineData.cameraMode.value);

    return (
        <DigitalTwinCameraModeButtonContainer>
            <DigitalTwinCameraModeButton
                variant="outlined"
                color="primary"
                selected={cameraMode === DigitalTwinCameraMode.Orbit}
                onClick={() => setCameraMode(DigitalTwinCameraMode.Orbit)}
            >
                <FontAwesomeIcon icon={["fas", "earth-europe"]} />
                <span>{translate(Content.map10.digitalTwin.cameraModes.orbit)}</span>
            </DigitalTwinCameraModeButton>
            <DigitalTwinCameraModeButton
                variant="outlined"
                color="primary"
                selected={cameraMode === DigitalTwinCameraMode.Fly}
                onClick={() => setCameraMode(DigitalTwinCameraMode.Fly)}
            >
                <FontAwesomeIcon icon={["fas", "drone"]} />
                <span>{translate(Content.map10.digitalTwin.cameraModes.fly)}</span>
            </DigitalTwinCameraModeButton>
            <DigitalTwinCameraModeButton
                variant="outlined"
                color="primary"
                selected={cameraMode === DigitalTwinCameraMode.Walk}
                onClick={() => setCameraMode(DigitalTwinCameraMode.Walk)}
            >
                <FontAwesomeIcon icon={["fas", "street-view"]} />
                <span>{translate(Content.map10.digitalTwin.cameraModes.walk)}</span>
            </DigitalTwinCameraModeButton>
        </DigitalTwinCameraModeButtonContainer>
    );
};

const DigitalTwinCameraModeButtonContainer = styled.div`
    position: absolute;
    bottom: 35px;
    right: 10px;
    flex-direction: column;
    ${media.medium} {
        bottom: 40px;
        right: 60px;
        flex-direction: row;
    }

    display: flex;
    align-items: flex-end;
    gap: 10px;
`;

const DigitalTwinCameraModeButton = styled(Button)<{ selected: boolean }>`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: ${iconButtonSize};
    background-color: ${(props) => (props.selected ? props.theme.primaryColors.focusAccent : props.theme.typographyColors.blank)};
    font-size: ${fontSizes.small};
    text-wrap: nowrap;

    :hover {
        background-color: ${(props) => (props.selected ? props.theme.primaryColors.focusAccent : props.theme.secondaryColors.light50)};
    }

    ${(props) => (props.selected ? `color: ${props.theme.typographyColors.blank};` : "")}

    svg {
        height: ${iconWidth.small};
        margin-right: ${inlineTextIconMargin};
    }
    span {
        flex: 1;
    }
`;
